import { render, staticRenderFns } from "./HeaderPostmatchReferee.vue?vue&type=template&id=0d233eb3&scoped=true&"
import script from "./HeaderPostmatchReferee.vue?vue&type=script&lang=js&"
export * from "./HeaderPostmatchReferee.vue?vue&type=script&lang=js&"
import style1 from "./HeaderPostmatchReferee.vue?vue&type=style&index=1&id=0d233eb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d233eb3",
  null
  
)

export default component.exports